// extracted by mini-css-extract-plugin
export var content = "_9k-3";
export var list = "_9k-4";
export var settingsContent = "_9k-7";
export var settingsPanel = "_9k-8";
export var state = "_9k-6";
export var triggerBadge = "_9k-2";
export var triggerButton = "_9k-1";
export var triggerShell = "_9k-0";
export var unreadDot = "_9k-5";